import React from 'react';
import { BRAND, isMarketGB } from 'src/constants/main';
import { StockModelCardHeaderStyledAC } from './AC/StockModelCardHeaderStyled.AC';
import { StockModelCardHeaderStyledAP } from './AP/StockModelCardHeaderStyled.AP';
import { StockModelCardHeaderStyledDS } from './DS/StockModelCardHeaderStyled.DS';
import { StockModelCardHeaderStyledOV } from './OV/StockModelCardHeaderStyled.OV';
import { StockModelCardHeaderStyledOVGB } from './OV/StockModelCardHeaderStyled.OVGB';
import { StockModelCardHeaderStyled } from './StockModelCardHeaderStyled';
import { SC } from 'src/styles/theme';
import { BrandTypes } from 'src/types/brands';
import { IPromo } from 'src/interfaces/IOfferItem';
import { VDStatus } from '../../../../services/stock/models/stockItems.service.model';

export type StockModelCardHeaderProps = SC & {
    title: string;
    isBooked?: boolean;
    engineInfo?: string[];
    isUnderlineDisplayed?: boolean;
    isPromoEnabled?: boolean;
    numCar?: string;
    hasPromoCode?: boolean;
    isMarketingStickerEnabled?: IPromo;
    stockCount?: number;
    allModelsCount?: number;
    isStockSlice?: boolean;
    specPackTitle?: string;
    mileage?: string;
    registrationDate?: string;
    VDStatus?: VDStatus;
};

const StockModelCardHeader = (props: StockModelCardHeaderProps) => {
    if (BRAND === BrandTypes.AC) return <StockModelCardHeaderStyledAC {...props} />;
    if (BRAND === BrandTypes.AP) return <StockModelCardHeaderStyledAP {...props} />;
    if (BRAND === BrandTypes.DS) return <StockModelCardHeaderStyledDS {...props} />;
    if (BRAND === BrandTypes.OV)
        return isMarketGB ? <StockModelCardHeaderStyledOVGB {...props} /> : <StockModelCardHeaderStyledOV {...props} />;
    return <StockModelCardHeaderStyled {...props} />;
};

export default StockModelCardHeader;
